import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface SolicitudPlanSiembra {
  id: number;
  cuit: string;
  razonSocial: string;
  mail: string;
  celular?: string;
  distribuidorId: number;
  distribuidor?: {
    id: number;
    name: string;
    email?: string;
    bolsas?: Array<any>;
    cuit?: string;
    userPadre?: {
      id?: number;
      name?: string;
      bolsas?: Array<any>;
      cuit?: string;
    };
  };
  user?: {
    id: number;
    name: string;
    email?: string;
    cuit?: string;
  };
  facturaFileUrl?: string;
  facturaFileName?: string;
  archivoFileUrl?: string;
  archivoFileName?: string;
  numeroFactura?: string;
  nroFactura?: string;
  tipo: 'INDIVIDUAL' | 'ARCHIVO' | string;
  nombreLote: string;
  hectareas: number;
  fechaSiembra: string;
  tipoCultivo: string;
  insumo: string;
  variedad?: string;
  cantidadInsumo: number;
  latitud: string;
  longitud: string;
  localidadCercana?: string;
  provincia?: string;
  estado: 'PENDIENTE' | 'APROBADO' | 'RECHAZADO' | string;
  fechaAprobacion?: string;
  motivoRechazo?: string;
  userId?: number;
  createdAt?: string;
  updatedAt?: string;
  checked?: boolean;
}

export interface PromedioHistoricoInsumo {
  insumo: string;
  tipoCultivo: string;
  promedio: number;
}

@Injectable({
  providedIn: 'root'
})
export class SolicitudPlanSiembraService {
  private resourceUrl = `${environment.api}/solicitudplansiembra`;

  constructor(private http: HttpClient) {}

  search(filter: any, pageSize: number, paginaActual: number): Observable<any> {
    let params = '';

    if (filter?.estado) {
      params += `&estado=${Array.isArray(filter.estado) ? filter.estado.join(',') : filter.estado}`;
    }
    if (filter?.empresa) {
      params += `&empresa=${Array.isArray(filter.empresa) ? filter.empresa.join(',') : filter.empresa}`;
    }
    if (filter?.distribuidorId) {
      params += `&distribuidorId=${Array.isArray(filter.distribuidorId) ? filter.distribuidorId.join(',') : filter.distribuidorId}`;
    }
    if (filter?.email) {
      params += `&email=${filter.email}`;
    }
    if (filter?.cuit) {
      params += `&cuit=${filter.cuit}`;
    }
    if (filter?.razonSocial) {
      params += `&razonSocial=${filter.razonSocial}`;
    }
    if (filter?.variedad) {
      params += `&variedad=${encodeURIComponent(filter.variedad)}`;
    }
    if (filter?.tipo) {
      params += `&tipo=${Array.isArray(filter.tipo) ? filter.tipo.join(',') : filter.tipo}`;
    }
    if (filter?.productor) {
      params += `&productor=${Array.isArray(filter.productor) ? filter.productor.join(',') : filter.productor}`;
    }

    return this.http.get<any>(
      `${this.resourceUrl}?_sort=createdAt&_order=DESC&registros=${pageSize}&paginaActual=${paginaActual}${params}`
    );
  }

  getAll(filter: any = {}): Observable<any> {
    let params = '';

    if (filter?.estado) {
      params += `&estado=${Array.isArray(filter.estado) ? filter.estado.join(',') : filter.estado}`;
    }
    if (filter?.empresa) {
      params += `&empresa=${Array.isArray(filter.empresa) ? filter.empresa.join(',') : filter.empresa}`;
    }
    if (filter?.distribuidorId) {
      params += `&distribuidorId=${Array.isArray(filter.distribuidorId) ? filter.distribuidorId.join(',') : filter.distribuidorId}`;
    }
    if (filter?.email) {
      params += `&email=${filter.email}`;
    }
    if (filter?.cuit) {
      params += `&cuit=${filter.cuit}`;
    }
    if (filter?.razonSocial) {
      params += `&razonSocial=${filter.razonSocial}`;
    }
    if (filter?.variedad) {
      params += `&variedad=${encodeURIComponent(filter.variedad)}`;
    }
    if (filter?.tipo) {
      params += `&tipo=${Array.isArray(filter.tipo) ? filter.tipo.join(',') : filter.tipo}`;
    }
    if (filter?.productor) {
      params += `&productor=${Array.isArray(filter.productor) ? filter.productor.join(',') : filter.productor}`;
    }

    return this.http.get<any>(`${this.resourceUrl}?_sort=createdAt&_order=DESC${params}`);
  }

  getById(id: number): Observable<SolicitudPlanSiembra> {
    return this.http.get<SolicitudPlanSiembra>(`${this.resourceUrl}/getById/${id}`);
  }

  update(id: number, data: FormData | any): Observable<SolicitudPlanSiembra> {
    return this.http.put<SolicitudPlanSiembra>(`${this.resourceUrl}/${id}`, data);
  }

  updateEstado(id: number, estado: 'APROBADO' | 'RECHAZADO', motivoRechazo?: string): Observable<SolicitudPlanSiembra> {
    const body: any = { estado };
    if (estado === 'RECHAZADO') {
      body.motivoRechazo = motivoRechazo;
    }
    return this.http.put<SolicitudPlanSiembra>(`${this.resourceUrl}/${id}`, body);
  }

  importarSolicitudes(data: any): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.resourceUrl}/importar`, data, { observe: 'response' });
  }

  getPromediosHistoricos(campaniaId?: number): Observable<PromedioHistoricoInsumo[]> {
    const params = campaniaId ? `?campaniaId=${campaniaId}` : '';
    return this.http.get<PromedioHistoricoInsumo[]>(`${this.resourceUrl}/promedios-historicos${params}`);
  }
}
